import { Box, Button, ButtonGroup, Grid, Table, TableBody, TableHead, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { institutionSelector } from "../../../../store/researchauthoritiesSlice";
import StyledTableCell from "../../Components/Tables/StyledTableCell";
import StyledTableRow from "../../Components/Tables/StyledTableRow";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import service from "../../Helpers/gifservices";
import Note from "../../Components/applicants/Note";
import { grantStatus } from "../../Constants";
import { useLoading } from "../../../../providers/loadingProvider";

const useStyles = makeStyles((theme) => ({
  infoIcon: {
    marginLeft: 5,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom:10,
  },
  button: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
}));

export default function Grantees() {
  const classes = useStyles();
  const loading = useLoading(); 
  const institution = useSelector(institutionSelector);
  const [grants, setGrants] = useState([]);
  const tableHeaders = [
    { label: "View Applicantion", width: "14%" },
    { label: "Name", width: "10%" },
    { label: "Grant Number", width: "15%" },
    { label: "Email", width: "15%" },
    { label: "Actual Payments(€)", width: "14%" },
    { label: "Current Budget(€)", width: "14%" },
    { label: "Reports", width: "15%" },
    { label: "Note", width: "10%" },
  ];

  const downloadGrantStatus=async(applicantId)=>{
    const loadingId = loading.addLoading("Downloading Grantee Status");
    await service.downloadGranteeStatus({applicantId});
    var data = await service.downloadGranteeStatus({applicantId});
    if (!(data instanceof Blob)) {
      return;
    }
    const blob = new Blob([data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `Grantee Status.pdf`;
    link.click();
    loading.removeLoading(loadingId);
  }
  
  const createPDF = async (proposalId, proposalNumber) => {
    if (!Boolean(proposalId)) return;
    const loadingId = loading.addLoading("Downloading Proposal Info");
    const pdfPath = await service.createProposalPDF({ proposalId });
    await service.downloadRawFile({
      path: pdfPath,
      filename: proposalNumber,
    });
    loading.removeLoading(loadingId);
  };

  const UpdateGrantNote = async (grantId, note) => {
    const loadingId = loading.addLoading("Updating Note");
    await service.UpdateGrantRAnote({ grantId, note });
    loading.removeLoading(loadingId);
  };

  const getGtants = useCallback(async () => {
    const loadingId = loading.addLoading("Loading Grantees");
    const grantStatusList = [grantStatus.grant, grantStatus.completedArchived, grantStatus.frozen, grantStatus.grantExtension, grantStatus.canceled, grantStatus.returnToRA, grantStatus.approvedByRA, grantStatus.approvedByGIF, grantStatus.delayedStart, grantStatus.completed, ];
    var grants = await service.GetApplicantsGrantees({
      institutionId: institution.id,
      grantStatusList
    });
    setGrants(grants);
    loading.removeLoading(loadingId);
  }, [institution.id, loading]);

  useEffect(() => {
    getGtants();
  }, [getGtants]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box className={classes.header}>
          <Typography variant="subtitle2">Grants</Typography>
          <InfoOutlinedIcon className={classes.infoIcon} color="primary" />
        </Box>
      </Grid>
      <Table className={classes.table}>
        <TableHead>
          <StyledTableRow>
            {tableHeaders.map((header) => (
              <StyledTableCell
                key={header.label}
                style={{ width: header.width }}
              >
                {header.label}
              </StyledTableCell>
            ))}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {grants.map((grant, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>
                <Button
                  startIcon={<PictureAsPdfRoundedIcon />}
                  className={classes.button}
                  onClick={()=>createPDF(grant.applicant.proposalfullnumber, grant.applicant.proposalName)}
                >
                  View PDF
                </Button>
              </StyledTableCell>
              <StyledTableCell>
                {`${grant.applicantFirstName} ${grant.applicantLastName}`}
              </StyledTableCell>
              <StyledTableCell>
                {grant.grantNumber}
              </StyledTableCell>
              <StyledTableCell>{`${grant.emailadress}`}</StyledTableCell>
              <StyledTableCell>{`${grant.actualPayments}`}</StyledTableCell>
              <StyledTableCell>{`${grant.currentBudget}`}</StyledTableCell>
              <StyledTableCell>
                <ButtonGroup
                  orientation="vertical"
                  color="primary"
                  aria-label="vertical contained primary button group"
                  variant="contained"
                  size="small"
                >
                  <Button
                    className={classes.button}
                    onClick={()=>downloadGrantStatus(grant.applicant.id)}
                  >
                    Grantee Status
                  </Button>
                  <Button className={classes.button}>Financial Status</Button>
                </ButtonGroup>
              </StyledTableCell>
              <StyledTableCell>
                <Note text={grant.notesFromRA}  onSave={(note)=>UpdateGrantNote(grant.grantId, note)}/>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </Grid>
  );
}
